import { openBlock, createElementBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "25",
  fill: "none",
  viewBox: "0 0 24 25"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M3.092 10.057h17.824M16.442 13.961h.01M12.005 13.961h.009M7.558 13.961h.01M16.442 17.848h.01M12.005 17.848h.009M7.558 17.848h.01M16.044 2.652v3.291M7.966 2.652v3.291"
    }, null, -1),
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M16.238 4.232H7.771C4.834 4.232 3 5.868 3 8.875v9.05c0 3.055 1.834 4.728 4.771 4.728h8.458c2.946 0 4.771-1.645 4.771-4.652V8.875c.01-3.007-1.816-4.643-4.762-4.643",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const IconCalendar = { render };
export {
  IconCalendar as default,
  render
};
//# sourceMappingURL=calendar.svg.js.map
